export default (n: number) => {
  let nf = Intl.NumberFormat();
  return nf.format(n);
};
